import React,{useContext,useEffect, useState, useRef,useReducer} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { SaveIcon, AddIcon, CopyIcon, DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, LoadPrioIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Chips } from 'primereact/chips';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import { uiT as t } from '../../../utils/uiTranslate';


export default function TrainingTemplateAdd({training_template, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);

    const [formTrainingTemplate,setformTrainingTemplate] = useState(training_template);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training"))?false:true);

    function addNewTrainingType(){
        dispatch({type:'create_new_tab',name: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'), translationKey: 'TrainingTemplateAdd.Text.Nova_sablona_skolenia', legacyLabel: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'),page:'TrainingTemplateAdd',props:{training_template: null,type:'add'},mask:'trng008'})
    }
    function copyTrainingType(){
        dispatch({type:'create_new_tab',name: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'), translationKey: 'TrainingTemplateAdd.Text.Nova_sablona_skolenia', legacyLabel: t('TrainingTemplateAdd.Text.Nova_sablona_skolenia'),page:'TrainingTemplateAdd',props:{training_template: formik.values,type:'add'},mask:'trng008'})
    }

    useEffect(() => {
        // Update the document title using the browser API
        if(formTrainingTemplate!=null){
            if(user.permissions?.includes("edit training"))setScrollIcons(false);
        }
    },[formTrainingTemplate]);

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = '*Povinné';
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formTrainingTemplate==null?{
            name:'',department_id:'',description:'',copy_records:false
        }:formTrainingTemplate,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            if(values?.copy_records)formData.append("training_template_id",training_template.id);
            if(formType=="add"){
                postRequest('/api/training_templates', formData,true)
                .then((response) => {
                    const created = response?.data ?? response;
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    if(created){
                        setformTrainingTemplate(created);
                        formik.setValues(created);
                    }
                    setFormType("edit");
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/training_templates/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    const updated = response?.data ?? response;
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    if(updated)setformTrainingTemplate(updated);
                    formik.setValues(values);
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const fetchRecord = async (direction, currentId) => {
        setDialogText?.(t('Common.LoadingShort'));
        setVisible?.(true);
        try {
            const url = `/api/training_templates/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}`;
            const r = await getRequest(url);
            return r?.data ?? null;
        } finally {
            setVisible?.(false);
        }
    };
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createAsyncNavigateHandlers(fetchRecord, setformTrainingTemplate, () => formik.values?.id);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingType()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTrainingType()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('TrainingTypeAdd.Text.Nova_typ_skolenia'),"TrainingTypeAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingTypeAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SABLONA_SKOLENIA')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-md font-semibold text-gray-800"
                            >{t('ServiceTaskPlanner.TemplateNameLabel')}</label>
                            <input 
                                name='name'
                                type="text" required
                                onChange={formik.handleChange} value={formik.values.name}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="department_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('TrainingTemplateList.Text.Oddelenie_sablony')}</label>
                            <select required
                            name='department_id'
                            onChange={formik.handleChange} value={formik.values.department_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                            {(state.departments || []).map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Description')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>  
                        {(training_template!=null && type=="add") && <div className="flex align-items-center mt-2">
                            <Checkbox name="copy_records" value="copy_records" onChange={(e) => formik.setFieldValue("copy_records",e.checked)} checked={formik.values.copy_records} />
                            <label htmlFor="copy_records" className="ml-2">{t('Ui.R67.Kopirovat_aj_skolenia_sablony')}</label>
                        </div>}   
                        <button className='hidden' type='submit' ref={submitRef}></button>
            </div>
            </div>
            </div> 
             </form>
            </div>
            </> 
            );
} 
